/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

export const xmlTemplates = {
  wfmContextRequest:
    '<p1:publishRequest xmlns:p1="http://ws.dotmed.gehc.com/dataexchange/">\n' +
    '    <p1:topic>\n' +
    '        <p1:name>{{TOPIC}}</p1:name>\n' +
    '        <p1:cacheable>false</p1:cacheable>\n' +
    '    </p1:topic>\n' +
    '    <p1:source>{{SOURCENAME}}</p1:source>\n' +
    '    <p1:data xmlns:p2="http://ws.dotmed.gehc.com/">\n' +
    '        <p2:name>OWNERINSTANCE</p2:name>\n' +
    '        <p2:type>STRING</p2:type>\n' +
    '        <p2:size>1</p2:size>\n' +
    '        <p2:deliveryType>STRING</p2:deliveryType>\n' +
    '        <p2:string>{{OWNERINSTANCE}}</p2:string>\n' +
    '    </p1:data>\n' +
    '    <p1:data xmlns:p2="http://ws.dotmed.gehc.com/">\n' +
    '        <p2:name>MESSAGE_ID</p2:name>\n' +
    '        <p2:type>STRING</p2:type>\n' +
    '        <p2:size>1</p2:size>\n' +
    '        <p2:deliveryType>STRING</p2:deliveryType>\n' +
    '        <p2:string>{{MESSAGE_ID}}</p2:string>\n' +
    '    </p1:data>\n' +
    '    <p1:data xmlns:p2="http://ws.dotmed.gehc.com/">\n' +
    '        <p2:name>ACTION_TYPE</p2:name>\n' +
    '        <p2:type>STRING</p2:type>\n' +
    '        <p2:size>1</p2:size>\n' +
    '        <p2:deliveryType>STRING</p2:deliveryType>\n' +
    '        <p2:string>{{ACTION_TYPE}}</p2:string>\n' +
    '    </p1:data>\n' +
    '    <p1:status/>' +
    '</p1:publishRequest>'
};
